import { getScaleToFillImageURL } from '@wix/image-client-api/dist/imageClientSDK';
export function getWixImageUrl(image, targetWidth, targetHeight) {
    if (!image || !image.name) {
        return;
    }
    if (image.width && image.height) {
        targetHeight = (targetWidth / image.width) * image.height;
    }
    return getScaleToFillImageURL(image.name, image.width, image.height, targetWidth, targetHeight);
}
//# sourceMappingURL=image.js.map